/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sd_Section_SegmentInputs */



/**
* | output |
* | --- |
* | "Segment to Process" |
*
* @param {Sd_Section_SegmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sd_section_segment = /** @type {((inputs?: Sd_Section_SegmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sd_Section_SegmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segmenter vers Processus")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segment zum Verarbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segmento per elaborare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сегмент для обработки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Segmentar para procesar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分段处理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントからプロセスへ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रक्रिया के लिए खंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Segmentar para Processar")
	return /** @type {LocalizedString} */ ("Segment to Process")
});